export enum MedicinesRadioGroupId {
  CONTINUOUS_MEDICATION = 340513
}

export enum MedicinesRadioGroupValuesId {
  CONFIRMED  = 'N',
  DENIED     = 'S',
  UNKNOWN    = 'D'
}

export enum ContinuousMedicationRadioGroup {
  CONFIRMED = 0,
  DEFINED = 1,
  UNKNOWN = 2,
}